"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const ui_1 = require("@mapmaker/ui");
function GenericLoader({ size = "medium", }) {
    return (0, jsx_runtime_1.jsx)(ui_1.LoadingSpinner, { active: true, size: size });
}
exports.default = GenericLoader;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiR2VuZXJpY0xvYWRlci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL3NoYXJlZC9HZW5lcmljTG9hZGVyLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSxxQ0FBOEM7QUFPOUMsU0FBd0IsYUFBYSxDQUFDLEVBQ3BDLElBQUksR0FBRyxRQUFRLEdBQ0s7SUFDcEIsT0FBTyx1QkFBQyxtQkFBYyxJQUFDLE1BQU0sUUFBQyxJQUFJLEVBQUUsSUFBSSxHQUFJLENBQUM7QUFDL0MsQ0FBQztBQUpELGdDQUlDIn0=